import { motion } from "motion/react";
import { ErrorScreen } from '../../../common/ui/ErrorScreen';
import { useTranslation } from '../../../i18n/useTranslation';
import { CategorySelectForm } from './CategorySelectForm';
import { useCategorySelectPageViewModel } from './categorySelectPageViewModel';
import { TextContent } from 'src/lib/common/ui/TextContent';
import { SanitizedMarkup } from 'src/lib/common/ui/SanitizedMarkup';
import styles from './CategorySelectPage.module.scss';

export function CategorySelectPage() {
  const { t } = useTranslation();
  const viewModel = useCategorySelectPageViewModel();

  if (viewModel.loading) {
    return <></>;
  }

  if (viewModel.error) {
    return <ErrorScreen error={ viewModel.error } />;
  }

  return (
    <div className={ styles.container }>
      <div className={ styles.containerInner }>

        <motion.div className={ styles.block } initial={{ scale: "var(--anim-block-scale-initial)", opacity: "var(--anim-block-opacity-initial)" }} animate={{ scale: "var(--anim-block-scale-animate)", opacity: "var(--anim-block-opacity-animate)" }} transition={{ duration: 0.4 }}>

          <motion.section className={ styles.infoBlock } initial={{  opacity: 0 }} animate={{  opacity: 1 }} transition={{ duration: 0.5 }}>
            <div className={ styles.infoBlockInner }>
              <header className={ styles.infoHeader }>
                <h1 className={ styles.infoTitle }>
                  { t('category_title') }
                </h1>
              </header>
              <div className={ styles.infoContent }>
                <TextContent>
                  <p>
                    <SanitizedMarkup html={ t('category_description_1') } />
                  </p>
                  <p>
                    <SanitizedMarkup html={ t('category_description_2') } />
                  </p>
                  <p>
                    <SanitizedMarkup html={ t('category_description_3') } />
                  </p>
                </TextContent>
              </div>
            </div>
          </motion.section>

          <motion.section className={ styles.actionBlock } initial={{ translateY: "var(--anim-action-translatey-initial)", opacity: "var(--anim-action-opacity-initial)" }} animate={{ translateY: "var(--anim-action-translatey-animate)", opacity: "var(--anim-action-opacity-animate)" }} transition={{ duration: 0.4 }}>
            <div className={ styles.actionBlockInner }>
              <CategorySelectForm viewModel={ viewModel } />
            </div>
          </motion.section>

        </motion.div>

      </div>
    </div>
  );
}
